module.exports = __webpack_public_path__ + "img/bombas_de_achique.726009e6.jpg";